import { z } from 'zod';
import { ipv4Regex, ipv6BracketedRegex } from './helpers/ip-address.ts';

export const INVALID_HOST = 'Invalid host address';
export const MISSING_HOST_ERR = 'Please provide a host for the DNS server to bind to';

const makeErrorMap =
  (emptyErrorMessage: string): z.ZodErrorMap =>
  (issue, ctx) => {
    if (issue.code === 'invalid_string' && issue.validation === 'regex') {
      if (!ctx.data) {
        return { message: emptyErrorMessage };
      }

      return { message: INVALID_HOST };
    }
    return { message: ctx.defaultError };
  };

export const makeRequiredIPAddressSchema = (emptyErrorMessage = MISSING_HOST_ERR) =>
  z.union([
    z.string({ errorMap: makeErrorMap(emptyErrorMessage) }).regex(ipv4Regex),
    z.string({ errorMap: makeErrorMap(emptyErrorMessage) }).regex(ipv6BracketedRegex),
  ]);
